import { customFetch } from '#/services/customFetch'
import type { BlogListParams, BlogPaginatedResponse } from '../types/blog.types'

export async function getBlogs(
  params: BlogListParams = {},
): Promise<BlogPaginatedResponse> {
  const query = new URLSearchParams()
  if (params.page) query.set('page', params.page.toString())
  if (params.limit) query.set('limit', params.limit.toString())
  if (params.tags) query.set('tags', params.tags)
  if (params.search) query.set('search', params.search)
  if (params.exclude) query.set('exclude', params.exclude)

  const queryString = query.toString()
  const endpoint = `/student/blogs${queryString ? `?${queryString}` : ''}`

  return customFetch<BlogPaginatedResponse>(endpoint)
}
